<div class="appointment-booking-wizard-callout borderless">
  <div class="message message-warning">
    <p><%= I18n.errors.recoverable.primary_phone_invalid %></p>
  </div>
</div>

<div class="step-form">
  <div class="fieldset">
    <div class="field">
      <label class="field-label"><%= I18n.patient.labels.primary_phone %></label>
      <div class="field-tel">
        <input class="field-input field-tel__input" data-appointment-booking-wizard-behaviour="field-input" type="tel" name="primary_phone" pattern="<%= I18n.patient.validations.primary_phone %>" required placeholder="<%= I18n.placeholders.with_required.replace('%{placeholder}', I18n.patient.placeholders.primary_phone) %>" value="<%- primary_phone %>">
      </div>
      <span class="validation-error"><%= I18n.errors.incorrect_format.phone %></span>
    </div>
  </div>
</div>
